import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Star, MapPin } from 'lucide-react';
export function TrustBar() {
  const stats = [{
    icon: <Users className="w-6 h-6 text-gold-400" data-id="element-357" />,
    value: '+500',
    label: 'dueños confían'
  }, {
    icon: <BookOpen className="w-6 h-6 text-gold-400" data-id="element-358" />,
    value: '6+6',
    label: 'Tomos + Bonos'
  }, {
    icon: <Star className="w-6 h-6 text-gold-400 fill-gold-400" data-id="element-359" />,
    value: '4.9/5',
    label: 'calificación'
  }, {
    icon: <MapPin className="w-6 h-6 text-gold-400" data-id="element-360" />,
    value: '🌎',
    label: 'Argentina'
  }];
  return <section className="py-8 border-y border-navy-800 bg-navy-900/50" data-id="element-361">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-362">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-363">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center justify-center space-y-2" data-id="element-364">
              <div className="p-3 bg-navy-800 rounded-full border border-navy-700" data-id="element-365">
                {stat.icon}
              </div>
              <div className="text-2xl font-bold text-white" data-id="element-366">{stat.value}</div>
              <div className="text-sm text-blue-200/70 uppercase tracking-wider" data-id="element-367">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}